const init = () => {
  const heading = document.getElementById('PageNavbarHeading')

  const handleResize = () =>
    heading.closest('.sticky-navbar')
    .style.setProperty('--heading-height', heading.offsetHeight + 'px')

  const resizeObserver = new ResizeObserver(handleResize)
  resizeObserver.observe(heading)
}

document.addEventListener('DOMContentLoaded', init)
